<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import FilePickerDialog from 'dashboard/components-next/file-picker/FilePickerDialog.vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  libraries: { type: Array, default: () => [] },
  libraryRecords: { type: Array, default: () => [] },
  selectedLibraryId: { type: [String, Number], default: null },
  libraryLoading: { type: Boolean, default: false },
  attachedRecordIds: { type: Array, default: () => [] },
  uploading: { type: Boolean, default: false },
});

const emit = defineEmits([
  'update:modelValue',
  'update:selectedLibraryId',
  'attach',
  'upload',
  'refresh-library',
  'close',
]);

const { t } = useI18n();

const sources = computed(() =>
  (props.libraries || []).map(library => ({
    id: library.id,
    label: library.event_documents
      ? t('PLANNING.SHOW.DOCUMENTS_PICKER_EVENT_LIBRARY')
      : library.name,
    icon: library.event_documents ? 'i-lucide-files' : 'i-lucide-folder',
  }))
);

const items = computed(() =>
  (props.libraryRecords || []).map(record => ({
    ...record,
    typeLabel: t('PLANNING.SHOW.DOCUMENTS_PICKER_TYPE_DOCUMENT'),
  }))
);

const onSelect = ({ ids }) => {
  emit('attach', { record_ids: ids });
};

const onUpload = ({ file }) => {
  emit('upload', { file });
};
</script>

<template>
  <FilePickerDialog
    :model-value="modelValue"
    :sources="sources"
    :items="items"
    :selected-source-id="selectedLibraryId"
    :source-loading="libraryLoading"
    :excluded-ids="attachedRecordIds"
    :uploading="uploading"
    multiple
    :search-placeholder="t('PLANNING.SHOW.DOCUMENTS_PICKER_SEARCH')"
    :empty-label="t('PLANNING.SHOW.DOCUMENTS_PICKER_EMPTY_LIBRARY')"
    :no-results-label="t('PLANNING.SHOW.DOCUMENTS_PICKER_NO_RESULTS')"
    :upload-hint="t('PLANNING.SHOW.DOCUMENTS_PICKER_UPLOAD_HINT')"
    @update:model-value="value => emit('update:modelValue', value)"
    @update:selected-source-id="id => emit('update:selectedLibraryId', id)"
    @refresh-source="id => emit('refresh-library', id)"
    @select="onSelect"
    @upload="onUpload"
    @close="emit('close')"
  />
</template>
